import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HintMusicThPolicyComponent } from './hint-music-th-policy/hint-music-th-policy.component';



@NgModule({
  declarations: [HintMusicThPolicyComponent],
  imports: [
    CommonModule
  ]
})
export class HintMusicThModule { }
